import React, { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useCancelarAiEspecial = ({ formik, dadosAIEspecial, dadosOs }) => {
  const [showModalCancelar, setShowModalCancelar] = useState({
    show: false,
    numeroAuto: null,
  });

  const { request, data, errors, isLoading } = useApiClient();

  const { setErrors } = formik;
  useEffect(() => {
    if (!data && !errors) return;

    if (data) {
      toast.success("Auto de Infração cancelado com sucesso.");
      window.location.reload();
    }

    if (errors) {
      setErrors((curr) => ({ ...curr, ...errors }));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    setShowModalCancelar({ show: false });
  }, [setShowModalCancelar, data, errors, setErrors]);

  const cancelaAiEspecial = useCallback(
    (values) => {
      request(apiRoutes.fiscalizacao.autoinfracao.cancelarAutoInfracao, values);
    },
    [request],
  );

  const cancelarAiEspecialModal = (
    <>
      <FormAlert formik={formik} data={data} errors={errors} isLoading={isLoading} dismissible />
      <EfisModal
        show={showModalCancelar.show}
        title="Justificar Cancelamento"
        size="md"
        closeHandler={() => setShowModalCancelar({ show: false })}
        primaryLabel="Cancelar"
        secondaryLabel="Fechar"
        body={`Auto de Infração número ${showModalCancelar.numeroAuto}`}
        confirmationHandler={() => {
          cancelaAiEspecial({
            sequencialAcaoFiscal: dadosOs.acaoFiscal,
            sequencialAutoInfracao: dadosAIEspecial?.sequencialAutoAberto,
            txJustificativa: document.getElementsByName("txJustificativa")[0].value,
          });
        }}
      >
        <span>
          Justificativa:
          <br />
          <textarea name="txJustificativa" rows="4" cols="50" resize="none" />
        </span>
      </EfisModal>
    </>
  );

  return {
    cancelarAiEspecialModal,
    setShowModalCancelar,
  };
};

export default useCancelarAiEspecial;
